import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { Tools } from '../../../core/utils/tools';

@Component({
    selector: 'sl-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputComponent implements OnInit {
    @ViewChild('inputField') inputField: ElementRef;

    @Input() tagId?: string;
    @Input() type = 'text';
    @Input() isDisabled = false;
    @Input() hasFloatingLabel = false;
    @Input() placeholderKey: string;
    @Input() inputPlaceholderKey?: string;
    @Input() control: AbstractControl;
    @Input() minLength?: number;
    @Input() maxLength?: number;
    @Input() minValue?: number;
    @Input() maxValue?: number;
    @Input() inputSize?: number;
    @Input() customStyle?: object;

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() readonly blur = new EventEmitter<void>();
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() readonly input = new EventEmitter<any>();

    ngOnInit(): void {
        if (!this.tagId) {
            this.tagId = Tools.Utils.newGuid();
        }
    }

    onBlur(): void {
        this.blur.emit();
    }

    onInput(event: any): void {
        this.input.emit(event);
    }
}
